/**
 * @desc addPoStock
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: Array<defs.tms.StockOccupyMasterAddRequestDto>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/stockOccupy/addPoStock`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
